import React from 'react';

const EditorContext = React.createContext();

export default EditorContext;
